import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CiPhone } from "react-icons/ci";
import "./Header.css";
import logoimage from "../../images/LogoMainSection.png";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleViewMore = () => {
    navigate("/Property");
  };
  const handleRedirect = () => {
    navigate("/contact-us");
  };
  const handleHomeRedirect = () => {
    navigate("/");
  };

  return (
    <>
      {/* Top bar */}
      <div className={`top-bar ${scrolled ? "scrolled" : ""}`}>
        <div className="top-bar-container">
          <p>
            <CiPhone /> <span className="highlight">+38348262282</span>
          </p>
        </div>
      </div>

      {/* Main Header */}
      <header className={`header ${scrolled ? "scrolled" : ""}`}>
        <div className="container-header">
          <div className="logo">
            <img src={logoimage} alt="" onClick={handleHomeRedirect} />
            <h3 onClick={handleHomeRedirect}>REAL-ESTATE</h3>
          </div>

          {/* Navigation Links */}
          <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
            <a id="pronat" onClick={handleViewMore}>
              Pronat
            </a>
            <a href="/">Lokacioni</a>
            <a id="sell" onClick={handleRedirect}>
              Ofroni Pronën Tuaj
            </a>
          </nav>

          {/* Burger Icon */}
          <div className="burger-menu" onClick={toggleMenu}>
            {menuOpen ? (
              <span className="close">✕</span>
            ) : (
              <span className="burger">☰</span>
            )}
          </div>
        </div>

        {/* Overlay when menu is open */}
        {menuOpen && <div className="menu-overlay" onClick={toggleMenu}></div>}
      </header>
    </>
  );
};

export default Header;
